import { v4 as uuidv4 } from "uuid";

export const genrateUUDI = (listsOfUUID: string[] = []) => {
  let newUUID: string = uuidv4()?.toLowerCase();
  if (listsOfUUID.includes(newUUID)) {
    return genrateUUDI(listsOfUUID);
  }
  return newUUID;
};
